import * as React from 'react';
import { useSelector } from 'react-redux';

import {
  selectEmailChangeHistoryData,
  selectEmailChangeHistoryLoading,
} from 'features/member/reducer/memberDetailSlice';

import DataTableLayout from 'components/common/table/datatable/DataTableLayout';
import DataTableHeader from 'components/common/table/datatable/DataTableHeader';
import NewDataTableBody from 'components/common/table/datatable/NewDataTableBody';

import emailHistoryColumns from './column';

import * as S from './EmailChangeHistory.styled';

const EmailChangeHistory = () => {
  const emailChangeHistoryData = useSelector(selectEmailChangeHistoryData);
  const isLoading = useSelector(selectEmailChangeHistoryLoading);

  return (
    <S.TableBlock>
      <DataTableLayout tableTitle={'Email Change History'} showPagination={false}>
        <DataTableHeader header={emailHistoryColumns} />
        <NewDataTableBody
          columns={emailHistoryColumns}
          dataList={emailChangeHistoryData}
          loading={isLoading}
        />
      </DataTableLayout>
    </S.TableBlock>
  );
};

export default EmailChangeHistory;
